import setAdditionalMetaOptions from '@/js/common/Service/setAdditionalMetaOptions';
import requestService from './request';

export default (tourCriteriaForTourRequest, callback) => requestService({
    url: `${window.appConfig.apiGatewayUrl}/frontend/hotelOffers`,
    data: {
        limit: 10000,
        ...tourCriteriaForTourRequest,
        ...setAdditionalMetaOptions(),
        sections: ['hotels', 'firstPaymentDefinitions', 'sortRate', 'hotelPhotos'],
    },
}, callback);